export const SITE_URL: string = (import.meta.env.VITE_SITE_URL as string) || 'https://directuitchina.nl';

export const LOGO_URL = 'https://static.readdy.ai/image/15bdf5788918520e40e960585d4ea965/3037d4ed8e2d758e66815cdcd69eb3cd.png';
